module.exports = __webpack_public_path__ + "static/media/item_bgp2.ecd7c384.png";